export default __webpack_public_path__ + "static/media/imgDarkEn4.9c2266a3.png";